import React from 'react';
import connectToStores from 'flummox/connect';
import Page from 'components/Page';
import DocumentTitle from 'react-document-title';
import { FHLayoutBase, FHLayoutRow, FHLayoutBody } from 'components/FHLayout';
import Slider from 'components/Slider';
import { Link } from 'react-router';
import IconLink from 'components/IconLink';
import checkMobile from 'utils/checkMobile';
import Page404 from 'pages/Page404';
import Video from 'components/Video';

import bgImage from './images/background.jpg';
import warnImage from './images/warning.svg';

import iconFooterCode from './footer-link-code.svg';
import iconFooterImprove from './footer-link-improve.svg';
import iconFooterRules from './footer-link-rules.svg';

const selectors = {
  contestData: store => {
    return {
      loading: store.state.loading,
      contestData: store.state.data
    };
  }
};

class ContestCM extends React.Component {
  constructor(props) {
    super(props);

    this.stripesCount = 4;

    this.state = {
      stripe: 1
    };

    this.pageStyle = {
      backgroundImage: `url(${bgImage})`,
      backgroundColor: '#00134b'
    };

    this.selectRandomStripe = this.selectRandomStripe.bind(this);
  }

  componentWillMount() {
    const { deviceType } = this.context;

    this.isMobile = checkMobile(deviceType, this.props.viewport);
  }

  getRandomStripe() {
    return Math.floor(1 + Math.random() * this.stripesCount);
  }

  selectRandomStripe() {
    let random = this.getRandomStripe();

    while (random === this.state.stripe) {
      random = this.getRandomStripe();
    }

    this.setState({
      stripe: random
    });
  }
}

const Contest = connectToStores(
  class Contest extends ContestCM {
    constructor(props) {
      super(props);
      this.number = this.props.flux.contestNumber;
    }
    render() {
      require('./Contest.styl');

      const { contestData, loading } = this.props;
      const slideNumber = typeof this.number !== 'undefined' ?
        this.number - 1 :
        Object.keys(contestData).filter(e => contestData[e].current)[0] - 1

      return (
        <Page style={this.pageStyle}>
          <DocumentTitle title="Программа Путешествие на Байкал с BAIKAL430" />

          {loading ? (
            <div>Loading...</div>
          ) : (
            <div
              className={'Contest ' + (this.isMobile ? 'Contest--mobile' : '')}
            >
              <Video src="/files/contest.mp4" />

              <div
                className={
                  'Contest__stripe Contest__stripe--one Contest__stripe--' +
                  this.state.stripe
                }
              ></div>

              <div
                className={
                  'Contest__stripe Contest__stripe--two Contest__stripe--' +
                  this.state.stripe
                }
              ></div>

              <FHLayoutBase>
                <FHLayoutRow>
                  <h4>Программа</h4>
                  <h1>Путешествие на&nbsp;Байкал с&nbsp;BAIKAL430</h1>
                </FHLayoutRow>

                <FHLayoutBody>
                  <Slider
                    onChange={this.selectRandomStripe}
                    slide={slideNumber}
                  >
                    {Object.values(contestData).map(item => {
                      return (
                        <div>
                          <h4>Группа победителей</h4>

                          {item.canOpen ? (
                            <Link
                              to={`/winners/${item.number}`}
                              className="Contest__number Contest__number--link"
                            >
                              {item.number < 10 ? '0' + item.number : item.number}
                            </Link>
                          ) : (
                            <span className="Contest__number">
                              {item.number < 10 ? '0' + item.number : item.number}
                            </span>
                          )}
                          
                          {item.defined ?
                            <span className={"Contest__caption Contest__caption--green"}>Определена</span>
                          :
                            <span className={"Contest__caption Contest__caption--orange"}>{item.defineText}</span>
                          }
                        </div>
                      );
                    })}
                  </Slider>
                </FHLayoutBody>

                <FHLayoutRow>
                  <div className="Contest__info">
                    <div className="Contest__info__line" />
                    <img src={warnImage} className="Contest__info__image" />
                    <div className="Contest__info__line" />
                  </div>

                  <p className="Contest__about">С&nbsp;1&nbsp;марта 2022 года в&nbsp;России стартовала обязательная <a href="https://честныйзнак.рф/o-chestnom-znake/" target="_blank">маркировка упакованной питьевой воды</a>. Теперь вы&nbsp;можете проверить подлинность каждой бутылки глубинной байкальской воды BAIKAL430&nbsp;в государственной информационной системе, используя мобильное приложение <a href="https://честныйзнак.рф/" target="_blank">Честный знак</a>. Приложение распознает DataMatrix код, напечатанный на&nbsp;этикетке, и&nbsp;предоставит информацию о&nbsp;подлинности воды.</p>
                  
                  <p className="Contest__about">В&nbsp;связи с&nbsp;изменениями в&nbsp;системе проверки подлинности программа &laquo;Путешествие на&nbsp;Байкал с&nbsp;BAIKAL430&raquo; в&nbsp;ее&nbsp;прежнем виде приостановлена. Мы&nbsp;приступим к&nbsp;возобновлению программы в&nbsp;новом формате после полного внедрения единой системы обязательной маркировки упакованной питьевой воды по&nbsp;всей стране. Все ранее введенные коды сохраняются и&nbsp;будут учтены после перезапуска программы. Участники получат смс-уведомления о&nbsp;перезапуске программы, информация также появится на&nbsp;<a href="https://baikal430.ru/" target="_blank">baikal430.ru</a>.</p>

                  <p className="Contest__about">В&nbsp;продаже еще остается глубинная байкальская вода BAIKAL430&nbsp;с прежней информацией о&nbsp;программе &laquo;Путешествие на&nbsp;Байкал&raquo; на&nbsp;этикетке и&nbsp;кодом проверки подлинности под крышкой. Ее&nbsp;замещение на&nbsp;новую займет некоторое время.</p>
                </FHLayoutRow>

                {/* <FHLayoutRow>
                  <IconLink
                    href="https://baikal430.ru/form"
                    icon={iconFooterCode}
                  >
                    Ввести код
                  </IconLink>{' '}
                  <IconLink
                    href="https://baikal430.ru/puteshestviye-baikal/"
                    icon={iconFooterImprove}
                  >
                    Программа путешествия
                  </IconLink>{' '}
                  <IconLink
                    href="https://baikal430.ru/files/rules.pdf"
                    icon={iconFooterRules}
                  >
                    Полные правила
                  </IconLink>
                </FHLayoutRow> */}
              </FHLayoutBase>
            </div>
          )}
        </Page>
      );
    }
  },
  selectors
);

const ContestDetail = connectToStores(
  class ContestDetail extends ContestCM {
    constructor(props) {
      super(props);
      this.number = this.props.params.number;
      this.props.flux.contestNumber = this.number;

      this.changeDetail = this.changeDetail.bind(this);
      const detail = this.props.contestData[this.number];
      if (detail) {
        this.props.flux.meta = detail.meta;
      }
    }

    static contextTypes = {
      router: React.PropTypes.any.isRequired
    };

    changeDetail(index) {
      const { contestData } = this.props;
      this.selectRandomStripe();

      const keys = Object.keys(contestData).filter(k => contestData[k].canOpen);
      if (keys[index]) {
        this.number = keys[index];
        setTimeout(() => {
          this.context.router.transitionTo('contestDetail', {
            number: this.number
          });
        }, 300);
        this.props.flux.contestNumber = this.number;
      }
    }

    render() {
      require('./Contest.styl');
      const { contestData, loading } = this.props;

      if (loading) {
        return (
          <Page style={this.pageStyle}>
            <div>Loading...</div>
          </Page>
        );
      }

      const detail = contestData[this.number];
      if (!detail) {
        this.is404 = true;
        return <Page404 {...this.props} />;
      }

      const contentShow = Object.keys(contestData)
        .filter(k => contestData[k].canOpen)
        .reduce((obj, key) => {
          obj[key] = contestData[key];
          return obj;
        }, {});

      return (
        <Page style={this.pageStyle}>
          <div
            className={'Contest ' + (this.isMobile ? 'Contest--mobile' : '')}
          >
            <DocumentTitle title={detail.title} />

            <div
              className={
                'Contest__stripe Contest__stripe--one Contest__stripe--' +
                this.state.stripe
              }
            ></div>

            <div
              className={
                'Contest__stripe Contest__stripe--two Contest__stripe--' +
                this.state.stripe
              }
            ></div>

            <div className="Contest__backplate">
              <div className="Contest__backplate__box"></div>
            </div>

            <div className="Contest__detail">
              <div className="Contest__box">
                <div className="Contest__layout">
                  <span className="Contest__title">Программа<br /><strong>Путешествие на Байкал с BAIKAL430</strong></span>

                  <div className="Contest__header">
                    <div className="Contest__group">
                      <h4>{detail.number < 10 ? '0' + detail.number : detail.number}</h4>
                      <span>Группа<br />победителей</span>
                    </div>

                    <div>
                      <span className={"Contest__caption Contest__caption--" + (detail.defined ? 'green' : 'orange')}>{detail.defineText}</span>
                    </div>

                    <div>
                      {detail.travelText ?
                        <span className={"Contest__caption Contest__caption--" + (detail.traveling ? 'green' : 'orange')}>{detail.travelText}</span>
                        : ''}
                    </div>
                  </div>

                  <h4>{detail.caption}</h4>
                  <h1>{detail.title}</h1>
                  {
                    <div className="Contest__box__content"
                      dangerouslySetInnerHTML={{
                        __html: detail.content
                      }}
                    />
                  }
                </div>
              </div>
            </div>

            <Link to="/winners" className="Contest__close"></Link>
          </div>
        </Page>
      );
    }
  },
  selectors
);

export { Contest, ContestDetail };



// WEBPACK FOOTER //
// ./src/pages/Contest/index.js